import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Revision} from "../../interfaces/Revision";
import { getUuidv4 } from '../../classes/utilities/Misc';

//Generators
function* idGenerator()
{
	for (let i = 0; ; i++)
	{
		yield i;
	}
}
const uniqueIdGenerator = idGenerator();

export interface IRevisionState {
	revisions: Record<number, Revision>;
	operations: Record<string, Operation[]>;
	simple: Record<string, any>; // Adjust the type as needed for simple
}

export interface Operation {
	[x: string]: any;
	nodes: any[]; // Replace `any` with the specific type of elements in the array if known
	command: string;
	params: Record<string, any>; // Replace `any` with the specific type for values in the `params` object if known
}

const initialState: IRevisionState = {
	revisions: {},
	operations: {},
	simple: {},
};

// TODO: fill in all the types!
const RevisionSlice = createSlice({
	name: "revision",
	initialState: initialState,
	reducers: {
		updateRevisions(state, action: PayloadAction<{revisions: Partial<Revision>[]}>)
		{
			if (!action.payload.revisions) return;
			state.revisions = {};
			const revisions = action.payload.revisions;
			for (let i = 0; i< revisions.length; i++)
			{
				const revisionId = revisions[i].id ?? getUuidv4();
				revisions[i].id = revisionId;
				state.revisions[revisionId] = revisions[i];
			}
		},
		setRevision(state, action)
		{
			if (!action.payload.revision) return;
			const revision = action.payload.revision;
			const revisionId = revision.id ?? getUuidv4();
			revision.id = revisionId;

			state.revisions[revisionId] = revision;
		},
		setSimple(state, action)
		{
			if (!state.simple[action.payload.file])
			{
				state.simple[action.payload.file] = {
					nodes: action.payload.nodes ?? [],
					mode: action.payload.mode
				};
			}
			state.simple[action.payload.file].nodes = action.payload.nodes ?? state.simple[action.payload.file].nodes;

			if (action.payload.mode)
			{
				for (const node of state.simple[action.payload.file].nodes)
				{
					node.mode = action.payload.mode;
				}
			}
		},
		setSimpleNode(state, action)
		{
			if (state.simple[action.payload.file].nodes[action.payload.nodeId])
			{
				state.simple[action.payload.file].nodes[action.payload.nodeId].mode = action.payload.mode;
			}
			else
			{
				console.log("Node doesn't exist");
			}
		},
		clearSimple(state, action)
		{
			if (state.simple[action.payload.file])
			{
				delete state.simple[action.payload.file];
			}
		},
		moveItem(state, action)
		{
			const newArray = state.operations[action.payload.file].filter((item, idx) => idx !== action.payload.operationIndex);
			newArray.splice(action.payload.index, 0, { ...state.operations[action.payload.file][action.payload.operationIndex] });

			state.operations[action.payload.file] = newArray;
		},
		addItem(state, action: PayloadAction<{file: string, operation?: Operation}>)
		{
			if (!state.operations[action.payload.file])
			{
				state.operations[action.payload.file] = [];
			}

			state.operations[action.payload.file].push(
				action.payload.operation ?? {
					nodes: [],
					command: "",
					params: {},
				}
			);

			// TODO what?
			// @ts-ignore
			state.operations[action.payload.file][state.operations[action.payload.file].length -1].id = uniqueIdGenerator.next().value;
		},
		setItemCommand(state, action)
		{
			if (!state.operations[action.payload.file]) return;
			if (!state.operations[action.payload.file][action.payload.operationIndex]) return;
			state.operations[action.payload.file][action.payload.operationIndex].command = action.payload.command;

			state.operations[action.payload.file][action.payload.operationIndex].params = {};
			if (action.payload.commandParams)
			{
				for (const commandParam of action.payload.commandParams)
				{
					state.operations[action.payload.file][action.payload.operationIndex].params[commandParam.id] = commandParam.default;
				}
			}
		},
		setItemParams(state, action)
		{
			if (!state.operations[action.payload.file]) return;
			if (!state.operations[action.payload.file][action.payload.operationIndex]) return;
			state.operations[action.payload.file][action.payload.operationIndex].params[action.payload.property] = action.payload.value;

		},
		removeItem(state, action)
		{
			state.operations[action.payload.file].splice(action.payload.operationIndex, 1);
		},
		setOperationNodes(state, action)
		{
			if (!state.operations[action.payload.file]) return;
			if (!state.operations[action.payload.file][action.payload.operationIndex]) return;
			state.operations[action.payload.file][action.payload.operationIndex].nodes = action.payload.nodes;
		},
	},
});

export default RevisionSlice;
